export class CashDocByReceiptsStore {
  inOut = true;
  isCreditCardPay = false;
  generatedViroPdfs= new Array<Uint8Array>();
  generatedNotoInvoicePdfs= new Array<Uint8Array>();
}

const store = new CashDocByReceiptsStore();
export default store;
